export const queryKey = {
  ageFilters: () => ['ageFilters'],
  popularKeywords: (ageValue: number) => ['popularKeywords', ageValue],
  beautyQueries: () => ['beautyQueries'],
  retailAds: (adSlotID: number) => ['retail-ads', adSlotID],
  suggestKeywords: (query: string) => ['suggestKeywords', query],
  configs: () => ['configs'],
  assistantInfo: (query: string) => ['assistantInfo', query],
  relatedKeywords: (query: string, searchType: string) => [
    'relatedKeywords',
    query,
    searchType,
  ],
  recommendedGoods: () => ['recommendedGoods'],
};
